import { render, staticRenderFns } from "./Table2Th.vue?vue&type=template&id=3bf2eeb9"
import script from "./Table2Th.vue?vue&type=script&lang=js"
export * from "./Table2Th.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports